import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=058ce543&scoped=true&"
import script from "./DefaultContainer.vue?vue&type=script&lang=ts&"
export * from "./DefaultContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultContainer.vue?vue&type=style&index=0&id=058ce543&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ce543",
  null
  
)

export default component.exports